var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenceMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.39 31.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lizenz mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 27.44,
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.96,
    y: 1.97,
    width: 19.57,
    height: 23.45,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.99,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 9.82,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 14.66,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 19.49,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2,23.55A6.44,6.44,0,0,0,25.82,30a6.52,6.52,0,0,0,1.63,4.33V44.59l4.75-3.74,4.87,3.72V34.2A6.53,6.53,0,0,0,38.58,30,6.44,6.44,0,0,0,32.2,23.55Z",
    transform: "translate(-13.19 -12.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72,30.35a4.53,4.53,0,1,0-9,0,4.82,4.82,0,0,0,1.3,3.3V41l3.23-2.6L35.53,41V33.53A4.78,4.78,0,0,0,36.72,30.35Z",
    transform: "translate(-13.19 -12.64)",
    fill: "#05548e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceMobil);
export default __webpack_public_path__ + "static/media/licence-mobil.8852834b6ac105e2e04223477b1358c6.svg";
export { ForwardRef as ReactComponent };